import React from 'react';
import styles from './teamSubmission.module.scss';

export default class Errors extends React.Component{
    constructor(props){
        super(props);
    }

    render(){
        var errors = (<span></span>);
        if (this.props.Errors && this.props.Errors.length > 0){
            errors = (
                <ul className={styles.errors}>
                    {this.props.Errors.map((e,i) => (<li key={e.message}>{e.message}</li>))}
                </ul>
            );
        }

        return(
            <div>
                {errors}
            </div>
        );
    }
}